//  get time from seconds (hh:mm:ss) or (mm:ss) and if nan return 00:00

export const getTimeFromSecs = (secs: number): string => {
  if (isNaN(secs)) return '00:00';
  const hours = Math.floor(secs / 3600);
  const minutes = Math.floor((secs % 3600) / 60);
  const seconds = Math.floor(secs % 60);

  const hoursString = hours < 10 ? `0${hours}` : hours;
  const minutesString = minutes < 10 ? `0${minutes}` : minutes;
  const secondsString = seconds < 10 ? `0${seconds}` : seconds;

  return hours > 0
    ? `${hoursString}:${minutesString}:${secondsString}`
    : `${minutesString}:${secondsString}`;
};

export function millisToMinutesAndSeconds(millis: number) {
  const minutes = Math.floor(millis / 60000);
  const seconds = ((millis % 60000) / 1000).toFixed(0);
  return minutes + ':' + (Number(seconds) < 10 ? '0' : '') + seconds;
}
